// Normal chat follows the live tail only by opt-in (see work_stream_scroll.js).
// Normal chat refuses bottom pins on every platform while a response is in
// progress, so a delayed send / keyboard pin can never land on the tail.
export function isMobileReadingChat(platform, isCoworkerChat) {
  return (platform === 'ios' || platform === 'android') && !isCoworkerChat;
}

export function shouldHoldChatScroll({ isCoworkerChat, isInferencing, hasAssistantResponse, followLive }) {
  // Cancel even delayed send/keyboard pins once the response starts. Explicit
  // jump-to-bottom remains available, as does positioning settled history.
  return !isCoworkerChat && isInferencing && hasAssistantResponse && !followLive;
}
